/**
 * Created by Jan on 03.05.2017.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Animations = Lfl.Animations || {};

    (function (Animations, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Animations, 'EventThrottler')) {
            return;
        }

        /*
         |===============================================================================================================
         | Class definition
         |===============================================================================================================
         */

        // TODO Later - Cleanup::I - Move to Events namespace or remove entirely.
        //      Consider replacing this method with the underscore's _.throttle(); and _.debounce();
        //      If not, then we need to have some added value. We should be able to detect if passed object is a
        //      _.throttle instance, so type detection is not it. Also consider separating the two mechanisms.
        /**
         * Note: When writing new code, consider using _.throttle() or _.debounce() instead of this class.
         *
         * Throttles the callback frequency down, so that if registered as an event handler (e.g. in an onScroll()),
         * the registered callback is not called so frequently.
         *
         * This is especially important for very rapidly firing events, such as scrolling, which get triggered with such
         * frequency that even fast handlers considerably harm the application's performance.
         *
         * @param {Object} parameters
         * @param {function} parameters.callback
         * @param {int} [parameters.callbackDelay]
         * @param {int} [parameters.endingHandleDelay]
         *
         * @memberOf Lfl.Animations
         * @lends Lfl.Animations.EventThrottler
         * @constructor
         */
        Lfl.Animations.EventThrottler = function (parameters) {
            /*
             |-----------------------------------------------------------------------------------------------------------
             | Construction
             |-----------------------------------------------------------------------------------------------------------
             */

            var callback = parameters.callback;

            if (typeof parameters.callbackDelay === 'undefined') {
                parameters.callbackDelay = 100;
            }
            /**
             * The time added between individual event handler calls. In milliseconds.
             *
             * Note: That is not the same as period! I.e.: if the call takes 50 ms on average and the delay is 100ms,
             * the "period" is 150ms (Indeed, a period in the exact physics sense is not defined since the call is not
             * periodic, technically speaking.).
             *
             * TODO MOBA II - decide: delay or period? Implement both and allow a choice? See #periodOrDelay below.
             *      Upd: the Underscore library already has a method for this.
             *      The difference between delay and period is in how we repeat the calls after the first one:
             *          For period we run in a setInterval
             *          For delay between runs we run in setTimeout
             *
             * @type {int}
             */
            var callbackDelay = parameters.callbackDelay;


            if (typeof parameters.endingHandleDelay !== 'undefined' &&
                parameters.endingHandleDelay < callbackDelay) {
                console.error("Received an endingHandleDelay lower than period." +
                    "That will cause the handler to fire more often than the delay would indicate." +
                    "Please use a separate throttler if you need longer period than ending handle delay");
            }

            /**
             * @type {int} The time after which the ending handle is triggered. Should be larger than callback delay. In milliseconds.
             */
            var endingHandleDelay = parameters.endingHandleDelay;
            var waiting;
            var lastReturnedValue;
            /**
             * The identifier which can be used to prevent the final ending callback call from being called. See below.
             *
             * Calling the callback call a call of a callback is kind of calling out to all the grammar nazis out there.
             *
             * @var {number}
             */
            var endingHandleTimeoutId;
            var thoseArguments;

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */


            /**
             * Performs the provided function with throttling defined by this object.
             *
             * I.e. performs the action defined by the callback parameter, but makes sure it does not happen too often.
             *
             * Note: Arguments passed to this function will be passed on to the listener.
             *
             * @return boolean
             */
            this.performTheThrottledCallback = function () {
                // The latest arguments should be used for the ending handle.
                thoseArguments = arguments;
                if (waiting) {
                    return lastReturnedValue;
                }
                waiting = true;

                // Clear previous scheduled end handle
                clearTimeout(endingHandleTimeoutId);

                lastReturnedValue = callback.apply(null, arguments);

                setTimeout(function () {
                    waiting = false;
                }, callbackDelay);

                if (typeof endingHandleDelay !== 'undefined') {
                    // Schedule an extra execution of the callback after the handleDelay (e.g. 200ms)
                    // in case the scrolling stops before the next time the event would be triggered (e.g in next 100ms)
                    endingHandleTimeoutId = setTimeout(function () {
                        // TODO Later - how to return the value from this callback?
                        //      Upd: Can only be handled by promises.
                        //        And do we event want to return a result? We can easily return via context variables,
                        //        so there should be no need for it ever.
                        callback.apply(null, thoseArguments);
                    }, endingHandleDelay);
                }

                return lastReturnedValue;
            };

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */

        };

        /*
        |-------------------------------------------------------------------------------------------------------------------
        | Static methods
        |-------------------------------------------------------------------------------------------------------------------
        */

        /**
         * Creates a new Event throttler wrapping the listener if the listener is not already.
         *
         * Note: We can not pass parameters this way.
         * @param listener
         * @returns {Lfl.Animations.EventThrottler}
         * @memberOf {Lfl.Animations.EventThrottler}
         */
        Lfl.Animations.EventThrottler.wrapInThrottlerIfNot = function (listener) {
            var throttler;
            if (listener instanceof Lfl.Animations.EventThrottler) {
                throttler = listener;
            } else {
                throttler = new Lfl.Animations.EventThrottler({callback: listener});
            }
            return throttler;
        }


    }(Lfl.Animations, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
